import React from 'react';

import { useLocation, useResolvedPath } from '@gogame/screens';

export const useTreeItem = path => {
  const location = useLocation();
  const resolvedPath = useResolvedPath(path);

  const { currentItem, openItem } = React.useMemo(() => {
    const locationPathname = location.pathname.toLowerCase();
    const toPathname = resolvedPath.pathname.toLowerCase();
    const currentItem = locationPathname === toPathname;
    const openItem = locationPathname.indexOf(toPathname) !== -1;
    return {
      currentItem,
      openItem,
    };
  }, [location, resolvedPath]);

  const [collapsedItem, collapseItem] = React.useState(false);

  React.useEffect(() => {
    collapseItem(!openItem && !currentItem);
  }, [openItem, currentItem]);

  const handleClickLink = React.useCallback(() => {
    collapseItem(state => !state);
  }, []);

  return {
    currentItem,
    openItem: openItem && !collapsedItem,
    onClickLink: handleClickLink,
  };
};

export default useTreeItem;
